import { Pipe, PipeTransform } from '@angular/core';
import { IsoCountriesService } from '@shared/services/iso-countries/iso-countries.service';

@Pipe({
  name: 'getCountryName',
  standalone: true
})
export class GetCountryNamePipe implements PipeTransform {

  constructor(private countriesService: IsoCountriesService) {

  }

  transform(countryCode: string): any {
    return this.countriesService.getName(countryCode);
  }

}
